import React from 'react';
import { Input, Pagination, Skeleton, Table } from 'antd';
import { useScrollUpPage } from 'shared/hooks';
import { SearchKeysNews } from 'shared/enums/news';
import { TVacationScheduleSubordinatePrepared } from 'shared/types/vacation-schedule.types';
import { ColumnsType } from 'antd/lib/table';
import { RequestStatusType } from 'shared/enums';
import { TableRowSelection } from 'antd/lib/table/interface';
import style from './index.module.scss';

type TProps = {
  dataSource: TVacationScheduleSubordinatePrepared[];
  columns: ColumnsType<TVacationScheduleSubordinatePrepared>;
  currentPage: number;
  currentSize: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  setCurrentSize: React.Dispatch<React.SetStateAction<number>>;
  total: number | undefined;
  onSearch?: (data: string, key: SearchKeysNews) => void;
  onRowClick?: (record: TVacationScheduleSubordinatePrepared[][number]) => void;
  loading?: boolean;
  rowSelection?: TableRowSelection<TVacationScheduleSubordinatePrepared>;
};

export const TableVSSubs = ({
  dataSource,
  columns,
  currentPage,
  setCurrentPage,
  total,
  setCurrentSize,
  currentSize,
  onSearch,
  onRowClick,
  loading,
  rowSelection,
}: TProps) => {
  const handlePagination = (value: number, pageSize: number) => {
    setCurrentSize(pageSize);
    setCurrentPage(value);
  };

  useScrollUpPage(currentPage);

  return (
    <>
      <Input.Search
        onSearch={data => {
          onSearch?.(data, SearchKeysNews.SEARCH);
        }}
        placeholder="Введите ФИО, ТН или должность сотрудника"
        className={style.input}
        allowClear
      ></Input.Search>
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <Table
            scroll={{ x: true }}
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            bordered
            rowSelection={rowSelection}
            rowClassName={record => {
              const isOnSupervisorForRequest =
                (record?.requests?.length || 0) > 0 &&
                record.requests?.every(elem => elem.status.type === RequestStatusType.consideredBySupervisor);
              const isOnSupervisorForScheduledRequest =
                (record?.scheduleRequests?.length || 0) > 0 &&
                record.scheduleRequests?.every(elem => elem.status.type === RequestStatusType.consideredBySupervisor);

              const isOnSupervisor = isOnSupervisorForRequest || isOnSupervisorForScheduledRequest;

              if (isOnSupervisor) {
                return style.row + ' ' + style.blue;
              }
              return style.row;
            }}
            onRow={record => ({
              onClick: () => {
                onRowClick?.(record);
              },
            })}
          />
          <div className={style.paginationWrap}>
            <Pagination
              defaultCurrent={1}
              showSizeChanger
              current={currentPage}
              total={total}
              pageSize={currentSize}
              onChange={(page, pageSize) => handlePagination(page, pageSize)}
            />
          </div>
        </>
      )}
    </>
  );
};
